import gql from 'graphql-tag';
import { concat } from 'ramda';

const GET_KEY_METRICS_CONTROL_GROUP_SUMMARY = `
  controlGroup(params: $params) {
    liftResults {
      count
      periodEnd
      controlAov
      exposedAov
      periodStart
      totalSales
      exposedTotalSales
      scaledControlSales
      scaledControlTransactionCount
    }

    salesAverages {
      control
      exposed
    }
  }
`;

const GET_KEY_METRICS_TRANSACTIONS_SUMMARY = `
  transactionSummary(params: $params) {
    result {
      transactionDate
      avgAov
      totalTransactionAmount
      numberOfTransactions
    }

    timeslice
  }

`;

export default (isExternalUser: boolean) => gql`
  query ControlGroupSummary($params: ReportInput!) {
    ${
      isExternalUser
        ? GET_KEY_METRICS_TRANSACTIONS_SUMMARY
        : concat(
            GET_KEY_METRICS_TRANSACTIONS_SUMMARY,
            GET_KEY_METRICS_CONTROL_GROUP_SUMMARY,
          )
    }
  }
`;
